<template>
    <div class="custom-tree">
        <el-tree v-bind="$attrs" :data="treeData" :render-content="renderContent" :lazy="lazy" :load="load" :filter-node-method="filterNodeMethod"></el-tree>
    </div>
</template>
<script>
export default {
    name:"yl-lc-tree",
    components: {
    },
    props: {
        treeData:{
            type:Array,
            default:[]
        },
        lazy:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        renderContent(h, { node, data }) {
            const count = this.countChildren(data); // 计算子集数量
            return (
                <div class="tree-content">
                    {node.label}
                    <span>{count}</span>
                </div>
            );
        },
        countChildren(node) {
            if (node.children) {
                return node.children.length;
            }
            return 0;
        },
        load(node, resolve) {
            if(this.lazy){
                if (node.level === 0) {
                    return resolve([{ name: node.data[0].label}]);
                }
                setTimeout(() => { 
                    if(node.data.children && node.data.children.length > 0){
                        const data = node.data.children;
                        return resolve(data);
                    }else{
                        return resolve([]);
                    }
                }, 500);
            }
        },
        filterNodeMethod(value,data){
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        }
    }
}
</script>
<style lang="less">
.tree-content{
    display: flex;
    justify-content: space-between;
    flex:1;
    align-items: center;
}
</style>
